import { PageHeaderConfig } from "@ui/context/component-config-context";
import { RecursivePartial } from "@voxmedia/duet-utils/typescript";

const pageHeaderConfig: RecursivePartial<PageHeaderConfig> = {
  size: "small",
  componentContext: {
    latestRecirc: {
      size: "small",
    },
  },
};

export default pageHeaderConfig;
